import { render, staticRenderFns } from "./ViewForgot.vue?vue&type=template&id=3dc48a34&"
import script from "./ViewForgot.vue?vue&type=script&lang=js&"
export * from "./ViewForgot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports